export const defaultPhotosPageSize = 10;
